import { useRequest } from "../../../app/hooks/useRequest";
import { createAlertDismissalRequest } from "../AlertRequests";

export const useCreateAlertDismissal = () =>
  useRequest(createAlertDismissalRequest);
